import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const SourceEffectivenessChart = ({ data, description }) => {
  // Data preparation for chart
  const sourceEffectivenessData = () => {
    const sourceCounts = {
      total: {},
      hired: {}
    };
    
    data.forEach(candidate => {
      if (!candidate.source) return;
      
      if (!sourceCounts.total[candidate.source]) {
        sourceCounts.total[candidate.source] = 0;
        sourceCounts.hired[candidate.source] = 0;
      }
      
      sourceCounts.total[candidate.source]++;
      
      if (candidate.stage === 'Hired') {
        sourceCounts.hired[candidate.source]++;
      }
    });
    
    return Object.entries(sourceCounts.total).map(([source, total]) => ({
      name: source,
      total,
      hired: sourceCounts.hired[source] || 0,
      rate: Math.round((sourceCounts.hired[source] || 0) / total * 100)
    }));
  };

  return (
    <div className="dashboard-card p-6 slide-in-up" style={{animationDelay: '700ms'}}>
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-lg font-semibold text-gray-800">Source Effectiveness</h3>
        <div className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-1 rounded-full">
          Conversion Rate
        </div>
      </div>
      {description && (
        <p className="text-sm text-gray-600 mb-4">{description}</p>
      )}
      <ResponsiveContainer width="100%" height={250}>
        <BarChart 
          data={sourceEffectivenessData()} 
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
          barGap={8}
          barCategoryGap={16}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" vertical={false} />
          <XAxis 
            dataKey="name" 
            tickLine={false} 
            axisLine={false} 
            style={{ fontSize: '12px' }} 
          />
          <YAxis 
            tickLine={false} 
            axisLine={false} 
            style={{ fontSize: '12px' }} 
          />
          <Tooltip 
            contentStyle={{ 
              borderRadius: '8px', 
              border: 'none', 
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
              fontSize: '12px'
            }} 
          />
          <Legend 
            iconType="circle" 
            iconSize={8} 
            align="right" 
            verticalAlign="top" 
            wrapperStyle={{ paddingBottom: '10px' }} 
          />
          <Bar 
            dataKey="total" 
            fill="#6366f1" 
            name="Total Candidates" 
            radius={[4, 4, 0, 0]}
            barSize={20}
          />
          <Bar 
            dataKey="hired" 
            fill="#0ea5e9" 
            name="Hired" 
            radius={[4, 4, 0, 0]}
            barSize={20}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SourceEffectivenessChart;
